import {PrimeIcons} from "primereact/api";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {InputText} from "primereact/inputtext";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {DetailsPanel} from "../../component/panels";
import {CellInputActionIcon} from "../../component/paramInput/InputGrossFloorArea";
import {useParameterValue} from "../../component/paramInput/paramHooks";
import {ROW_ACTION_COLUMN_STYLE} from "../../component/paramInput/RowDeleteIcon";
import {selectReadOnly} from "../../redux/persistenceSlice";

const DOC_PROPERTY_AUFLAGEN = "order_terms";

interface AuflagenRow {
    index: number;
    value: string;
    newRow: boolean;
}

export function PanelAuflagen() {
    const {t} = useTranslation();
    const readOnly = useSelector(selectReadOnly);
    const {parameterValues, onValueChange} = useParameterValue(DOC_PROPERTY_AUFLAGEN, "DOC_PROPERTY");

    const items: string[] = parameterValues.activeParameterValue ?? [];
    const rows: AuflagenRow[] = items.map((value, index) => ({index, value, newRow: false}));
    if (!readOnly) rows.push({index: items.length, value: "", newRow: true});

    const save = (updated: string[]) => void onValueChange(updated.length ? updated : null, null);

    const onBlur = (index: number, input: HTMLInputElement) => {
        const value = input.value.trim();
        input.value = value;
        if (value === (items[index] ?? "")) return;
        if (!value) save(items.filter((_, i) => i !== index));
        else if (index === items.length) save([...items, value]);
        else save(items.map((item, i) => (i === index ? value : item)));
    };

    return (
        <DetailsPanel icon={PrimeIcons.LIST} title={t("order.terms.title")}>
            <DataTable
                className="p-inputtext-sm text-sm inputtext"
                value={rows}
                dataKey="index"
                cellMemo={false}
                pt={{thead: {style: {display: "none"}}, bodyRow: {className: "!bg-transparent"}}}
                size="small"
            >
                {!readOnly && (
                    <Column
                        style={ROW_ACTION_COLUMN_STYLE}
                        body={(row: AuflagenRow) => (
                            <CellInputActionIcon
                                rowData={row}
                                onDelete={() => save(items.filter((_, i) => i !== row.index))}
                            />
                        )}
                    />
                )}
                <Column
                    field="value"
                    body={(row: AuflagenRow) => (
                        <InputText
                            key={`${row.index}-${row.value}`}
                            style={{width: "100%"}}
                            defaultValue={row.value}
                            disabled={readOnly}
                            onBlur={(e) => onBlur(row.index, e.target)}
                        />
                    )}
                />
            </DataTable>
        </DetailsPanel>
    );
}
